module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main